if (!customElements.get('advanced-reviews-page')) {
  customElements.define(
    'advanced-reviews-page',
    class AdvancedReviewsPage extends HTMLElement {
      constructor () {
        super();
        this.paginator = this.querySelector('.advanced-reviews-page-paginator__button');
      }

      paginatorHandle () {
        const pageLimiter = this.querySelector('.page-limiter');
        if (pageLimiter) {
          pageLimiter.removeAttribute('data-closed');
        }
        const root = this.paginator.closest('.advanced-reviews-page-paginator');
        if (root) {
          root.style.display = 'none';
        }
        pauseAllMedia(null, true);
      }

      connectedCallback () {
        if (this.paginator) {
          this.paginator.addEventListener('click', this.paginatorHandle.bind(this));
        }
      }

      disconnectCallback () {
        if (this.paginator) {
          this.paginator.removeEventListener('click', this.paginatorHandle.bind(this));
        }
      }
    },
  );
}